export default {
  id: 'recovr.jobItem.errorStage',
  name: 'jobItem.errorStage',
  displayName: 'Error Stage',
  valueType: 'string',
  objectType: 'jobItem',
  get: obj => {
    return obj?.errorStage;
  }
};